/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import TextEditor from "../../components/TextEditor";
import Header from "../../components/Header";
import Select from "react-select";
import Sidebar from "../../components/Sidebar";
import FeatherIcon from "feather-icons-react/build/FeatherIcon";
import { message } from "antd";
import { jwtDecode } from "jwt-decode";
import { fetchAllDepartments } from "../../services/departmentService";
import { createActivity, fetchUserById } from "../../services/activityService";
import "./ActivityCard.css";

const AddActivity = () => {
  const navigate = useNavigate();

  // Form state
  const [title, setTitle] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [conductedBy, setConductedBy] = useState("");
  const [activityMode, setActivityMode] = useState("");
  const [redirectUrl, setRedirectUrl] = useState("");
  const [description, setDescription] = useState("");
  const [bannerImage, setBannerImage] = useState(null);
  const [status, setStatus] = useState("Inactive");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [selectedDept, setSelectedDept] = useState(null);
  const [deptOptions, setDeptOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loggedInUserData, setLoggedInUserData] = useState(null);

  useEffect(() => {
    const fetchAndSetUser = async () => {
      const token = localStorage.getItem("token");
      if (token) {
        try {
          const decoded = jwtDecode(token);
          const user = await fetchUserById(decoded.id);
          setLoggedInUserData(user);
        } catch (error) {
          console.error("Error decoding token or fetching user:", error);
          localStorage.removeItem("token");
          setLoggedInUserData(null);
        } finally {
          setLoading(false);
        }
      } else {
        setLoading(false);
      }
    };

    fetchAndSetUser();
  }, []);

  useEffect(() => {
    const getDepartments = async () => {
      try {
        const data = await fetchAllDepartments();
        const formatted = data.map((dept) => ({
          value: dept.department_id,
          label: dept.department_name,
        }));

        setDeptOptions([{ value: null, label: "None" }, ...formatted]);
      } catch (error) {
        console.error("Failed to fetch departments:", error);
      }
    };

    getDepartments();
  }, []);

  const toggleStatus = () => {
    setStatus((prev) => (prev === "Active" ? "Inactive" : "Active"));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    // Create FormData object
    const formData = new FormData();

    let departmentId = "";
    if (loggedInUserData?.user_role === "2") {
      // Department Co-ordinator - use their department ID
      departmentId = loggedInUserData.department_id;
    } else {
      // Admin - use selected department or null
      departmentId = selectedDept?.value || null;
    }

    // Append all fields with the exact names expected by the API
    formData.append("title", title);
    formData.append("content", description);
    formData.append("status", status);
    formData.append("startDate", startDate);
    formData.append("endDate", endDate);
    formData.append("conductedBy", conductedBy);
    formData.append("mode", activityMode);
    formData.append("url", redirectUrl);
    formData.append("department", departmentId);

    // Add user email and parameter for backend logging
    if (loggedInUserData?.user_email) {
      formData.append("addedbyemail", loggedInUserData.user_email);
      const parameter =
        loggedInUserData?.user_role === "1" ? "Admin" : "Department";
      formData.append("parameter", parameter);
    }

    // Append files with correct field names
    if (bannerImage) formData.append("activity_image", bannerImage);

    try {
      const response = await createActivity(formData);
      message.success(response.message || "Activity created successfully!");
      navigate("/list-activities");
    } catch (error) {
      message.error(
        error.message || "Failed to create activity. Please try again."
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  const checkboxSection = (
    <>
      <div className="col-6">
        <div className="form-group local-forms">
          <label className="form-label d-block mb-2">
            Status: <strong>{status}</strong>
          </label>
          <label className="switch mt-4">
            <input
              type="checkbox"
              checked={status === "Active"}
              onChange={toggleStatus}
            />
            <span className="slider round"></span>
          </label>
        </div>
        <small className="d-block text-muted mt-5">
          Enable this to make the activity Active.
        </small>
      </div>
    </>
  );

  const submitButton = (
    <button
      type="submit"
      className="btn btn-primary submit-form me-2"
      disabled={isSubmitting}
    >
      {isSubmitting ? "Publishing..." : "Publish Activity"}
    </button>
  );

  const handleEditorChange = (valueOrActivity) => {
    setDescription(valueOrActivity?.target?.value || valueOrActivity);
  };

  return (
    <>
      <div className="main-wrapper">
        <Header />
        <Sidebar
          id="menu-item-activity"
          id1="menu-items-activity"
          activeClassName="add-activity"
        />

        <div className="page-wrapper">
          <div className="content">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="#">Activity</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <FeatherIcon icon="chevron-right" />
                    </li>
                    <li className="breadcrumb-item active">Add Activity</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-sm-12">
                <div className="card">
                  <div className="card-body">
                    <form onSubmit={handleSubmit} encType="multipart/form-data">
                      <div className="row">
                        <div className="col-12">
                          <div className="form-heading">
                            <h4>Activity Details</h4>
                          </div>
                        </div>

                        <div className="col-12 col-md-6 col-xl-6">
                          <div className="form-group local-forms">
                            <label>
                              Activity Title{" "}
                              <span className="login-danger">*</span>
                            </label>
                            <input
                              className="form-control"
                              type="text"
                              value={title}
                              onChange={(e) => setTitle(e.target.value)}
                              required
                            />
                          </div>
                        </div>

                        <div className="col-12 col-md-6 col-xl-6">
                          <div className="form-group local-forms">
                            <label>
                              Select Start Date{" "}
                              <span className="login-danger">*</span>
                            </label>
                            <input
                              className="form-control"
                              type="date"
                              value={startDate}
                              onChange={(e) => setStartDate(e.target.value)}
                              required
                            />
                          </div>
                        </div>

                        <div className="col-12 col-md-6 col-xl-6">
                          <div className="form-group local-forms">
                            <label>
                              Select End Date{" "}
                              <span className="login-danger">*</span>
                            </label>
                            <input
                              className="form-control"
                              type="date"
                              value={endDate}
                              onChange={(e) => setEndDate(e.target.value)}
                              required
                            />
                          </div>
                        </div>

                        <div className="col-12 col-md-6 col-xl-6">
                          <div className="form-group local-forms">
                            <label>
                              Conducted By{" "}
                              <span className="login-danger">*</span>
                            </label>
                            <input
                              className="form-control"
                              type="text"
                              value={conductedBy}
                              onChange={(e) => setConductedBy(e.target.value)}
                              required
                            />
                          </div>
                        </div>

                        <div className="col-12 col-md-6 col-xl-6">
                          <div className="form-group local-forms">
                            <label>
                              Select Activity Mode{" "}
                              <span className="login-danger">*</span>
                            </label>
                            <select
                              className="form-control"
                              value={activityMode}
                              onChange={(e) => setActivityMode(e.target.value)}
                              required
                            >
                              <option value="">Select Mode</option>
                              <option value="Online">Online</option>
                              <option value="Offline">Offline</option>
                              <option value="Hybrid">Hybrid</option>
                            </select>
                          </div>
                        </div>

                        {loggedInUserData?.user_role !== "2" ? (
                          <div className="col-12">
                            <div className="form-group local-forms">
                              <label>
                                Select Department (Type to search and select)
                                <span className="login-danger">*</span>
                              </label>
                              <Select
                                value={selectedDept}
                                onChange={setSelectedDept}
                                options={deptOptions}
                                components={{
                                  IndicatorSeparator: () => null,
                                }}
                                styles={{
                                  control: (base, state) => ({
                                    ...base,
                                    borderColor: state.isFocused
                                      ? "#2e37a4"
                                      : "rgba(46, 55, 164, 0.1)",
                                    boxShadow: "none",
                                    borderRadius: "10px",
                                    fontSize: "14px",
                                    minHeight: "45px",
                                  }),
                                }}
                              />
                            </div>
                          </div>
                        ) : (
                          <div className="col-12">
                            <div className="form-group local-forms">
                              <label>Department</label>
                              <input
                                type="text"
                                className="form-control"
                                value={
                                  deptOptions.find(
                                    (d) =>
                                      d.value === loggedInUserData.department_id
                                  )?.label || "Department not found"
                                }
                                disabled
                              />
                              {/* Hidden input to store the department ID */}
                              <input
                                type="hidden"
                                value={loggedInUserData.department_id}
                              />
                            </div>
                          </div>
                        )}

                        <div className="col-12 col-md-6 col-xl-6">
                          <div className="form-group local-forms">
                            <label>Redirect URL</label>
                            <input
                              className="form-control"
                              type="text"
                              placeholder="https://example.com"
                              value={redirectUrl}
                              onChange={(e) => setRedirectUrl(e.target.value)}
                            />
                          </div>
                        </div>

                        {checkboxSection}

                        <div className="col-12 mt-3">
                          <div className="form-group summer-mail">
                            <TextEditor
                              value={description}
                              onChange={handleEditorChange}
                            />
                          </div>
                        </div>

                        <div className="col-12 col-md-6 col-xl-6">
                          <div className="form-group local-forms">
                            <label>
                              Select Event Banner Image{" "}
                              <span className="login-danger">*</span>
                            </label>
                            <div className="d-flex flex-column align-items-start">
                              <label htmlFor="banner" className="upload mb-2">
                                Choose File
                              </label>
                              <input
                                type="file"
                                accept="image/*"
                                id="banner"
                                onChange={(e) =>
                                  setBannerImage(e.target.files[0])
                                }
                                className="form-control"
                                required
                              />
                              {bannerImage && (
                                <small className="text-muted mt-1">
                                  {bannerImage.name}
                                </small>
                              )}
                            </div>
                          </div>
                        </div>

                        <div className="col-12">
                          <div className="doctor-submit text-end">
                            {submitButton}
                            <Link
                              to="/list-activities"
                              className="btn btn-primary cancel-form"
                            >
                              Cancel
                            </Link>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="sidebar-overlay" data-reff="" />
    </>
  );
};

export default AddActivity;
